import {ieFix} from './vendor/polyfills';
import './vendor/picturefill.min';
import './vendor/swiper';

ieFix();
require('intersection-observer');
